export default __webpack_public_path__ + "static/media/Sri-Manakula-Vinayagar.6723ce5c.png";